import React, { useEffect, useState } from 'react';
import './DashboardPage.css';
import Navbar from '../../ui/Navbar/Navbar';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  getApplicationsAsync,
  getCurrentSessionId,
  getSessionsAsync,
  getSessions,
  getLoadingAppTimeout,
} from '../../../features/redux/appSlice';

function DashboardPage() {
  const dispatch = useDispatch();
  const sessions = useSelector(getSessions);
  const currentSessionId = useSelector(getCurrentSessionId);
  const [currentSession, setCurrentSession] = useState(null);
  const [hasHotlines, setHasHotlines] = useState(false);
  useEffect(() => {
    dispatch(getApplicationsAsync());
    dispatch(getSessionsAsync());
    setInterval(() => {
      dispatch(getSessionsAsync());
    }, 3000);
  }, []);

  useEffect(() => {
    const _currentSession = sessions.find((s) => s.id === currentSessionId);
    if (!currentSession || !_currentSession) {
      setCurrentSession(_currentSession);
    } else if (
      currentSession &&
      _currentSession &&
      _currentSession.id !== currentSession.id
    ) {
      setCurrentSession(_currentSession);
    }
  }, [currentSessionId, sessions, currentSession]);

  // const currentSession = sessions.find(s=>s.id === currentSessionId)
  const url = currentSession ? currentSession.url : '';
  return (
    <div className='dashboard-wrapper'>
      <Navbar />
      <div className='dashboard-content'>
        {!currentSession && (
          <div id='app-time-out-loader'>
            {hasHotlines && false && (
              <div
                style={{
                  fontSize: '30px',
                  width: '514px',
                  textAlign: 'center',
                  marginLeft: '-142px',
                  marginTop: '-70px',
                }}
              >
                {' '}
                User portal will load when you answer the Tremp call...{' '}
              </div>
            )}
            <svg
              width='100%'
              height='100%'
              viewBox='0 0 60 60'
              version='1.1'
              style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinecap: 'round',
              }}
            >
              <g transform='matrix(0.0294851,0,0,0.0523038,1.74445,1.73596)'>
                <rect
                  x='0'
                  y='0'
                  width='1920'
                  height='1080'
                  style={{ fill: 'white' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <circle
                  cx='1405'
                  cy='613'
                  r='129'
                  style={{ fill: 'rgb(232,248,244)' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1416.33,478.69C1426.78,475.955 1449.82,475.167 1458.38,493.892C1466.93,512.618 1455.74,529.494 1449.07,535.592'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '1.5px',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1418.54,471.07C1416.53,472.714 1411.13,478.383 1408.68,481.012L1420.13,483.973'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '1.5px',
                    strokeLinejoin: 'round',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1376.83,473.734L1378.79,478.896C1379.66,481.181 1379.63,483.707 1378.72,485.975L1376.97,490.366C1376.88,490.571 1377.09,490.774 1377.29,490.69L1381.89,488.816C1384.16,487.893 1386.69,487.856 1388.98,488.713L1393.98,490.581C1394.19,490.659 1394.39,490.445 1394.3,490.242L1392.46,486.233C1391.35,483.814 1391.27,481.046 1392.25,478.571L1394.25,473.54C1394.33,473.331 1394.12,473.128 1393.91,473.219L1389.17,475.338C1386.56,476.499 1383.58,476.464 1381.01,475.241L1377.17,473.42C1376.97,473.323 1376.75,473.523 1376.83,473.734Z'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(51,53,78)',
                    strokeWidth: '1.5px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1358.4,476.446C1356.37,475.759 1351.37,473.49 1347.65,469.91'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(51,53,78)',
                    strokeWidth: '1.5px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1360.86,488.458C1354.83,490.701 1339.37,494.484 1325.8,491.673'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(51,53,78)',
                    strokeWidth: '1.5px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M917.928,853.253C917.928,814.688 917.597,399.645 918.21,313.412C918.268,305.211 923.076,297.968 930.517,294.521L1165.9,185.507C1180.13,178.914 1196.4,189.31 1196.4,204.997L1196.4,229.087C1196.4,253.563 1196.04,720.951 1196.34,798.564C1196.36,804.501 1192.91,809.722 1187.5,812.175L946.19,921.63C932.949,927.636 917.928,917.965 917.928,903.426L917.928,853.253Z'
                  style={{ fill: 'rgb(230,230,233)', fillRule: 'nonzero' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M934.924,827.874C934.924,789.309 934.592,374.266 935.206,288.033C935.264,279.832 940.071,272.589 947.513,269.142L1182.89,160.128C1197.13,153.536 1213.4,163.931 1213.4,179.618L1213.4,203.708C1213.4,228.184 1213.04,695.572 1213.34,773.185C1213.36,779.122 1209.9,784.343 1204.5,786.796L956.038,899.494C946.146,903.98 934.924,896.759 934.924,885.897L934.924,827.874Z'
                  style={{
                    fill: 'white',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1166.88,215.685L979.542,299.312C974.896,301.387 971.904,305.999 971.904,311.088L971.904,458.92C971.904,468.469 981.921,474.706 990.49,470.492L1177.83,378.362C1182.24,376.193 1185.04,371.706 1185.04,366.791L1185.04,227.461C1185.04,218.12 1175.41,211.878 1166.88,215.685Z'
                  style={{
                    fill: 'rgb(232,248,244)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1141.56,548.265C1142.07,547.986 1142.56,547.676 1143.01,547.338L1143.61,548.143C1144.61,547.401 1145.51,546.533 1146.27,545.568L1145.48,544.948C1146.2,544.045 1146.79,543.05 1147.24,541.99L1148.16,542.381C1148.64,541.249 1148.97,540.048 1149.14,538.809L1148.14,538.676C1148.22,538.111 1148.26,537.537 1148.26,536.957L1148.26,534.509L1149.26,534.509L1149.26,529.613L1148.26,529.613L1148.26,524.717L1149.26,524.717L1149.26,519.822L1148.26,519.822L1148.26,514.926L1149.26,514.926L1149.26,510.03L1148.26,510.03L1148.26,505.134L1149.26,505.134L1149.26,500.239L1148.26,500.239L1148.26,495.343L1149.26,495.343L1149.26,490.447L1148.26,490.447L1148.26,485.551L1149.26,485.551L1149.26,480.656L1148.26,480.656L1148.26,478.208C1148.26,477.456 1148.2,476.726 1148.08,476.022L1149.07,475.857C1148.8,474.255 1148.26,472.767 1147.51,471.429L1146.64,471.917C1145.92,470.63 1144.99,469.49 1143.9,468.534L1144.56,467.782C1143.37,466.744 1142.02,465.909 1140.56,465.317L1140.18,466.243C1138.84,465.697 1137.4,465.374 1135.93,465.307L1135.97,464.308C1134.44,464.239 1132.87,464.427 1131.32,464.907L1131.61,465.862C1130.93,466.073 1130.25,466.345 1129.58,466.682L1127.49,467.731L1127.04,466.838L1122.86,468.936L1123.31,469.83L1119.12,471.929L1118.68,471.035L1114.49,473.134L1114.94,474.027L1110.76,476.126L1110.31,475.232L1106.13,477.331L1106.58,478.225L1102.4,480.323L1101.95,479.43L1097.76,481.528L1098.21,482.422L1094.03,484.521L1093.58,483.627L1089.4,485.726L1089.85,486.619L1085.67,488.718L1085.22,487.824L1081.04,489.923L1081.48,490.817L1077.3,492.915L1076.85,492.022L1072.67,494.12L1073.12,495.014L1068.94,497.113L1068.49,496.219L1064.31,498.318L1064.75,499.211L1060.57,501.31L1060.12,500.416L1055.94,502.515L1056.39,503.409L1052.21,505.507L1051.76,504.614L1047.58,506.712L1048.03,507.606L1043.84,509.705L1043.39,508.811L1039.21,510.91L1039.66,511.803L1035.48,513.902L1035.03,513.008L1030.85,515.107L1031.3,516.001L1027.11,518.099L1026.67,517.206L1022.48,519.304L1022.93,520.198L1018.75,522.297L1018.3,521.403L1014.12,523.502L1014.57,524.395L1010.38,526.494L1009.94,525.6L1005.75,527.699L1006.2,528.593L1002.02,530.691L1001.57,529.798L997.389,531.896L997.838,532.79L993.655,534.889L993.207,533.995L989.025,536.094L989.473,536.987L985.291,539.086L984.842,538.192L980.66,540.291L981.108,541.185L979.017,542.234C978.481,542.503 977.969,542.806 977.484,543.141L976.917,542.317C975.851,543.051 974.903,543.924 974.093,544.903L974.864,545.54C974.106,546.458 973.478,547.476 972.998,548.565L972.083,548.162C971.571,549.325 971.216,550.563 971.038,551.845L972.028,551.983C971.947,552.566 971.905,553.16 971.905,553.76L971.905,556.107L970.905,556.107L970.905,560.803L971.905,560.803L971.905,565.498L970.905,565.498L970.905,570.194L971.905,570.194L971.905,574.889L970.905,574.889L970.905,579.585L971.905,579.585L971.905,584.28L970.905,584.28L970.905,588.976L971.905,588.976L971.905,593.671L970.905,593.671L970.905,598.366L971.905,598.366L971.905,603.062L970.905,603.062L970.905,607.757L971.905,607.757L971.905,612.453L970.905,612.453L970.905,617.148L971.905,617.148L971.905,619.496C971.905,620.262 971.969,621.005 972.091,621.721L971.105,621.888C971.382,623.521 971.937,625.032 972.712,626.386L973.58,625.89C974.325,627.193 975.291,628.342 976.415,629.298L975.768,630.059C976.989,631.098 978.383,631.923 979.88,632.495L980.237,631.561C981.616,632.087 983.087,632.382 984.588,632.409L984.57,633.409C986.13,633.437 987.722,633.198 989.287,632.656L988.96,631.711C989.646,631.473 990.328,631.172 991,630.804L993.091,629.657L993.572,630.534L997.754,628.241L997.273,627.364L1001.46,625.072L1001.94,625.949L1006.12,623.656L1005.64,622.779L1009.82,620.486L1010.3,621.363L1014.48,619.07L1014,618.193L1018.18,615.901L1018.67,616.778L1022.85,614.485L1022.37,613.608L1026.55,611.315L1027.03,612.192L1031.21,609.899L1030.73,609.022L1034.91,606.73L1035.39,607.607L1039.58,605.314L1039.1,604.437L1043.28,602.144L1043.76,603.021L1047.94,600.728L1047.46,599.851L1051.64,597.559L1052.12,598.436L1056.31,596.143L1055.83,595.266L1060.01,592.973L1060.49,593.85L1064.67,591.557L1064.19,590.68L1068.37,588.388L1068.85,589.265L1073.04,586.972L1072.55,586.095L1076.74,583.802L1077.22,584.679L1081.4,582.386L1080.92,581.509L1085.1,579.217L1085.58,580.094L1089.76,577.801L1089.28,576.924L1093.47,574.631L1093.95,575.508L1098.13,573.215L1097.65,572.338L1101.83,570.046L1102.31,570.923L1106.49,568.63L1106.01,567.753L1110.2,565.46L1110.68,566.337L1114.86,564.044L1114.38,563.167L1118.56,560.875L1119.04,561.752L1123.22,559.459L1122.74,558.582L1126.92,556.289L1127.41,557.166L1131.59,554.873L1131.11,553.996L1135.29,551.704L1135.77,552.58L1139.95,550.288L1139.47,549.411L1141.56,548.265Z'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                    strokeDasharray: '4.67,4.67',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1054.1,718.026C1053.94,708.493 1043.87,702.403 1035.36,706.686L987.8,730.595C983.283,732.866 980.502,737.562 980.683,742.615L982.948,806.047C983.275,815.188 992.724,821.113 1001.09,817.424L1047.51,796.968C1052.28,794.869 1055.32,790.117 1055.23,784.912L1054.1,718.026Z'
                  style={{ fill: 'rgb(255,250,237)', fillRule: 'nonzero' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1042.36,713.056L994.804,736.965C990.636,739.061 988.07,743.393 988.237,748.056L990.502,811.488C990.804,819.922 999.523,825.389 1007.25,821.986L1053.66,801.53C1058.06,799.593 1060.87,795.209 1060.79,790.405L1059.66,723.519C1059.51,714.723 1050.22,709.104 1042.36,713.056Z'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1165.25,473.979L1014.69,549.531C1010.33,551.719 1007.57,556.179 1007.57,561.057L1007.57,626.793C1007.57,636.593 1018.07,642.812 1026.67,638.1L1177.23,555.561C1181.36,553.298 1183.93,548.963 1183.93,544.254L1183.93,485.505C1183.93,475.91 1173.82,469.676 1165.25,473.979Z'
                  style={{
                    fill: 'rgb(66,198,165)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M998.555,380.847C1004.56,380.847 1009.41,385.691 1009.41,391.697C1009.41,397.703 1004.56,402.547 998.555,402.547C992.549,402.547 987.705,397.703 987.705,391.697C987.705,385.691 992.549,380.847 998.555,380.847Z'
                  style={{
                    fill: 'rgb(66,198,165)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M961.582,366.296L948.95,361.858L962.729,355.582C964.874,354.606 966.574,352.86 967.492,350.689L972.794,338.165L978.296,351.081C979.221,353.253 980.93,354.998 983.082,355.968L996.542,362.039L984.016,366.739C981.612,367.642 979.681,369.487 978.672,371.848L972.69,385.845L967.234,371.769C966.24,369.207 964.175,367.207 961.582,366.296Z'
                  style={{
                    fill: 'rgb(255,214,105)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M966.175,414.545L963.73,413.629L967.156,412.152C969.32,411.219 971.055,409.508 972.018,407.357L973.285,404.525L974.516,407.585C975.397,409.776 977.069,411.555 979.202,412.569L982.444,414.111L979.811,415.039C977.39,415.892 975.422,417.698 974.365,420.038L972.879,423.329L971.714,420.132C970.773,417.55 968.749,415.508 966.175,414.545Z'
                  style={{
                    fill: 'white',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M899.611,318.713C897.544,317.648 892.014,315.467 886.426,315.268'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M910.801,311.58C908.003,305.197 899.303,290.322 886.895,281.883'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1140.71,605.988C1154.25,607.341 1172.86,624.035 1180.47,632.213C1184.7,639.827 1191.47,656.746 1190.62,682.126C1189.78,707.505 1210.93,738.806 1231.23,761.647C1247.47,779.92 1251.53,828.479 1251.53,850.475C1233.26,854.536 1214.59,875.854 1207.54,886.006L1262.53,886.006C1278.77,865.026 1283.96,790.975 1284.53,756.572C1342.73,763.339 1406.35,747.548 1430.88,738.806C1441.88,753.47 1467.43,788.38 1481.64,810.714C1495.85,833.048 1487.56,854.423 1481.64,862.319C1457.28,861.642 1443.85,880.648 1440.19,890.236L1490.1,890.236L1512.09,810.714C1506.17,804.792 1490.1,772.645 1490.1,756.572C1490.1,740.498 1501.94,735.422 1509.56,716.811C1515.65,701.921 1512.09,685.791 1509.56,679.588C1575.2,662.668 1593.87,616.139 1595,594.99C1574.7,638.304 1524.5,657.592 1501.94,661.822C1499.4,644.903 1466.41,638.981 1455.41,638.981L1355.59,638.981C1344.59,638.981 1251.53,641.519 1238,622.061C1227.17,606.495 1225.03,581.736 1225.31,571.303C1231.76,574.233 1243.63,586.229 1249.84,582.38C1256.26,578.408 1266.76,563.769 1257.46,554.463C1249.84,546.849 1238,550.233 1229.54,537.464C1217.27,518.952 1188.93,533.234 1160.17,540.848C1137.16,546.939 1107.72,546.769 1095.87,545.923C1091.64,582.3 1123.79,604.296 1140.71,605.988Z'
                  style={{
                    fill: 'white',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1238.84,704.967C1239.52,716.473 1222.21,732.885 1213.46,739.652C1195.87,716.642 1190.91,693.97 1190.62,685.51C1195.7,661.823 1220.23,655.901 1223.62,660.977C1227,666.052 1221.08,675.358 1217.69,678.742C1214.31,682.126 1211.77,691.432 1217.69,693.124C1223.62,694.816 1238,690.586 1238.84,704.967Z'
                  style={{ fill: 'rgb(26,30,55)', fillRule: 'nonzero' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1412.11,639.813C1408.73,641.166 1410.54,644.46 1412.11,647.426C1419.73,661.808 1435.8,660.962 1443.42,653.348C1451.03,645.734 1447.65,639.813 1443.42,639.813C1439.19,639.813 1416.34,638.121 1412.11,639.813Z'
                  style={{ fill: 'rgb(26,30,55)', fillRule: 'nonzero' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1353.94,740.414C1360.03,741.09 1360.99,752.539 1360.7,758.179C1342.09,762.489 1302.33,764.181 1282.03,759.871C1280.34,751.411 1283.72,732.8 1293.03,730.262C1302.33,727.724 1310.79,734.492 1315.02,742.952C1319.25,751.411 1330.25,750.565 1335.32,746.335C1340.4,742.106 1346.32,739.568 1353.94,740.414Z'
                  style={{
                    fill: 'rgb(66,198,165)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1163.55,549.387C1164.45,554.353 1169.64,556.781 1174.7,555.87C1179.76,554.96 1184.75,550.123 1183.86,545.157C1182.96,540.191 1181.32,538.389 1173.02,540.7C1167.78,542.619 1162.66,544.42 1163.55,549.387Z'
                  style={{ fill: 'rgb(26,30,55)', fillRule: 'nonzero' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1310.37,545.42L1353.88,545.42L1349.53,638.356L1335.15,639.202L1319.92,638.356L1310.37,545.42Z'
                  style={{ fill: 'rgb(230,230,233)', fillRule: 'nonzero' }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1295.14,518.229L1323.7,518.229L1326.42,546.78'
                  style={{
                    fill: 'none',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1316.9,545.42L1360.41,545.42L1356.05,638.356L1341.67,639.202L1326.45,638.356L1316.9,545.42Z'
                  style={{
                    fill: 'white',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1318.83,563.911L1359.44,563.911L1356.73,637.685L1342.19,638.357L1326.79,637.685L1318.83,563.911Z'
                  style={{
                    fill: 'rgb(255,214,105)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '2px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
              <g transform='matrix(0.06875,0,0,0.06875,-55.3486,-5.64884)'>
                <path
                  d='M1346.81,546.779C1346.81,544.359 1347.53,541.993 1348.87,539.981C1350.22,537.969 1352.13,536.401 1354.36,535.474C1356.6,534.548 1359.06,534.306 1361.43,534.778C1363.81,535.25 1365.99,536.416 1367.7,538.127C1369.41,539.838 1370.57,542.019 1371.05,544.392C1371.52,546.766 1371.28,549.226 1370.35,551.462C1369.42,553.698 1367.86,555.609 1365.84,556.954C1363.83,558.298 1361.47,559.016 1359.05,559.016L1359.05,546.779L1346.81,546.779Z'
                  style={{
                    fill: 'rgb(255,214,105)',
                    fillRule: 'nonzero',
                    stroke: 'rgb(26,30,55)',
                    strokeWidth: '4px',
                    strokeLinecap: 'butt',
                  }}
                />
              </g>
            </svg>
          </div>
        )}
        {currentSession && url && (
          <iframe
            onLoad={() => {
              document.getElementsByTagName('iframe')[0].focus();
            }}
            id='iframe'
            src={url}
            style={{ width: '100%', height: '90vh', border: '2px black solid' }}
            wmode='Opaque'
          />
        )}
      </div>
    </div>
  );
}

export default DashboardPage;
